<template>
  <main :key="code">
    <SectionView class="header" :title="status" :color="color">
      <div class="name fx">
        <span>
          <b>{{title}}</b>
          <i :style="{background: color}"></i>
        </span>
      </div>
      <div v-if="desc" class="desc">{{desc}}</div>
    </SectionView>

    <text-card
        v-if="explain"
        title="项目说明"
        :content="explain"
    ></text-card>

    <waterfall-card
        v-if="dynamics.length > 0"
        title="动态跟踪模式"
        :list="dynamics"
        labelKey="time"
        :valueKey="stackValueKey"
        stack="diff"
        line="av"
        format
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <!-- 平均值状态图 -->
    <waterfall-card
        v-if="dynamics.length > 0"
        title="平均值状态图"
        :list="dynamics"
        labelKey="time"
        colorKey="color"
        :valueKey="avValueKey"
        format
    ></waterfall-card>

    <graph-card
        v-if="relevancys.children.length > 0"
        title="身体关联项"
        :main="title"
        :color="relevancys.color"
        :list="relevancys.children"
        @select="openTissue"
    ></graph-card>

    <graph-card
        v-if="nutritions.children.length > 0"
        title="营养素关联项"
        :main="title"
        :color="nutritions.color"
        :list="nutritions.children"
        @select="openNutrition"
    ></graph-card>

    <diet-card
        v-if="diets.useless.length > 0 || diets.useful.length > 0"
        :useless="diets.useless"
        :useful="diets.useful"
    ></diet-card>

    <!-- 主要内脏关联比例图 -->
    <waterfall-card
        v-if="viscusRatios.length > 0"
        title="主要内脏关联比例图"
        :list="viscusRatios"
        labelKey="item_dict_name_simple"
        :valueKey="totalValueKey"
        axis="x"
        valueFormatter="{value}%"
        stack="total"
        :legends="legends"
    ></waterfall-card>

    <!-- 主要营养素关联比例图 -->
    <waterfall-card
        v-if="nutritiveRatios.length > 0"
        title="主要营养素关联比例图"
        :list="nutritiveRatios"
        labelKey="item_dict_name_simple"
        :valueKey="totalValueKey"
        axis="x"
        valueFormatter="{value}%"
        stack="total"
        :legends="legends"
    ></waterfall-card>

    <!-- 主要内脏平均值状态图 -->
    <waterfall-card
        v-if="viscusStatus.length > 0"
        title="主要内脏平均值状态图"
        :list="viscusStatus"
        colorKey="color"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
    ></waterfall-card>

    <!-- 主要营养素平均值状态图 -->
    <waterfall-card
        v-if="nutritionStatus.length > 0"
        title="主要营养素平均值状态图"
        :list="nutritionStatus"
        colorKey="color"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
    ></waterfall-card>

    <!--<list-card title="运动建议" :list="sports"></list-card>-->

    <!--<tag-card title="影响身体关联项" :list="relations"></tag-card>-->

    <text-card
        v-if="sports"
        title="运动建议"
        :content="sports"
    ></text-card>

    <text-card
        v-if="daily"
        title="起居建议"
        :content="daily"
    ></text-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import SectionView from "@/components/SectionView";
  import DietCard from "@/components/DietCard";
  import TextCard from "@/components/TextCard";
  import WaterfallCard from "@/components/WaterfallCard";
  import GraphCard from "../components/GraphCard";
  import {getReportLoopItem} from "../net/api";
  import DialogView from "../components/DialogView";

  export default {
    name: "Details",
    components: {DialogView, GraphCard, WaterfallCard, TextCard, DietCard, SectionView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        code: '',
        title: '',
        color: '#3BA272',
        status: '',

        // 介绍
        explain: '',

        relations: [
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
          {
            icon: 'https://st.aigtfd.com/image/report/qg1p.png',
            name: '免疫力'
          },
        ],

        desc: '',
        // 动态跟踪模式
        dynamics: [],

        // 身体关联项
        relevancys: {children: [], color: '#3BA272', system_code: ''},
        // 营养关联项
        nutritions: {children: [], color: '#3BA272', system_code: ''},
        // 饮食建议
        diets: {
          useful: [],
          useless: []
        },
        stackValueKey: {
          one: '初值',
          two: '终值',
        },
        // 通用态图列表数据关联项
        statusValueKey: {
          av: '均值',
          one: '初值',
          two: '终值',
        },
        // 平均值关联项
        avValueKey: {
          av: '均值',
        },
        totalValueKey: {
          shice_value: '实测值',
          bili_value: '标准',
        },
        // 主要内脏关联比例图
        viscusRatios: [],
        // 主要营养素关联比例图
        nutritiveRatios: [],
        // 主要内脏平均值状态图
        viscusStatus: [],
        // 主要营养素平均值状态图
        nutritionStatus: [],

        // 运动建议
        sports: '',
        // 起居建议
        daily: '',

        // 报告等级列表
        levels: [],

        // 解读说明弹窗
        interpret: false,
        legends: [
          {name: '实测值', colors: []},
          {name: '标准', colors: ['#C3C2C2']},
        ],
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand, checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.update(query);
      this.syncPageData(query);
    },

    beforeRouteUpdate(to, from, next) {
      this.$loading.start();
      const query = to.query;
      this.syncPageData(query, () => {
        this.update(query);
        // 滚动条滚动到顶部
        (document.scrollingElement || document.body).scrollTop = 0;
        this.$loading.stop();
      });
      next();
    },

    methods: {
      update(query) {
        this.packageNo = query.packageNo;
        this.checkcode = query.checkcode;
        this.rand = query.rand;

        this.title = query.title;
        this.color = query.color;
        this.code = query.code;
      },

      // 同步页面数据
      syncPageData(query, callback) {
        // 获取报告数据
        getReportLoopItem({
          packageNo: query.packageNo,
          rand: query.rand,
          checkcode: query.checkcode,
          system_code: query.code
        }).then((data) => {
          this.levels = data.colorData;
          // 处理状态
          for (let level of this.levels) {
            if (level.color === this.color) {
              this.status = level.str;
              break;
            }
          }

          this.desc = data.show_liuduan !== '未见异常风险' ? data.show_liuduan : null;
          this.explain = data.item_explain;
          this.dynamics = data.show_dongtai;
          this.relevancys = data.show_neizangguanlian;
          this.nutritions = data.show_yingyangguanlian;
          this.diets.useful = data.show_yinshijianyi.tolerantFood;
          this.diets.useless = data.show_yinshijianyi.noTolerantFood;
          this.viscusRatios = data.show_neizangbili_new;
          this.nutritiveRatios = data.show_yingyangbili_new;
          this.viscusStatus = data.show_neizangzhuangtai;
          this.nutritionStatus = data.show_yingyangzhuangtai;
          this.sports = data.show_yundongjianyi;
          this.daily = data.show_qijujianyi;

          // 处理 color 数据
          if (data.colorData) data.colorData.forEach((item) => {
            this.legends[0].colors.push(item.color);
          });

          if (callback) callback();
        })
      },

      // 跳转至身体关联项
      openTissue(index) {
        let row = index === 0 ? this.relevancys : this.relevancys.children[index - 1];
        this.$router.replace({path: '/details', query: {
          code: row.system_code, title: row.item_dict_name, color: row.color, ...(this.query)
        }})
      },

      // 跳转至营养素关联项
      openNutrition(index) {
        let row = index === 0 ? this.nutritions : this.nutritions.children[index - 1];
        this.$router.push({path: '/nutrition', query: {
          code: row.system_code, title: row.item_dict_name, color: row.color, ...(this.query)
        }})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    .name {
      position: relative;
      padding-top: 60px;
      padding-bottom: 88px;

      span {
        position: relative;
        padding: 0 10px;
      }

      b {
        position: relative;
        height: 36px;
        font-size: 50px;
        color: #333333;
        line-height: 36px;
        font-weight: 500;
        z-index: 1;
      }

      i {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -14px;
        content: "";
        display: block;
        height: 18px;
        background: #3BA272;
        border-radius: 9px;
      }
    }

    .desc {
      font-size: 30px;
      color: #333333;
      line-height: 46px;
    }
  }
</style>